import React from "react";
import NavigationHeader from "./NavigationHeader";
import Footer from "./Footer";

const Layout = ({ children }) => (
  <>
    <NavigationHeader />
    {children}
    <Footer />
  </>
);

export default Layout;